export default __webpack_public_path__ + "static/media/caen19.1f07466b.jpg";